const getRuntimeString = (value: string | undefined): string | null => {
  const trimmed = value?.trim();
  return trimmed ? trimmed.replace(/\/+$/, '') : null;
};

const getBackendBaseUrl = (): string => {
  const backendBaseUrl = getRuntimeString(process.env.REACT_APP_BACKEND_URL);
  if (!backendBaseUrl) {
    throw new Error(
      'Missing required environment variable REACT_APP_BACKEND_URL'
    );
  }
  return backendBaseUrl;
};

const getStaticBaseUrl = (): string => {
  const staticBaseUrl = getRuntimeString(
    process.env.REACT_APP_STATIC_BASE_URL
  );
  if (!staticBaseUrl) {
    throw new Error(
      'Missing required environment variable REACT_APP_STATIC_BASE_URL'
    );
  }
  return staticBaseUrl;
};

const getSupportEmail = (): string => {
  const supportEmail = process.env.REACT_APP_SUPPORT_EMAIL?.trim();
  if (!supportEmail) {
    throw new Error(
      'Missing required environment variable REACT_APP_SUPPORT_EMAIL'
    );
  }
  return supportEmail;
};

export const BACKEND_BASE_URL = getBackendBaseUrl();
export const STATIC_BASE_URL = getStaticBaseUrl();
export const SUPPORT_EMAIL = getSupportEmail();
